let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("O17sz")).then(() => parcelRequire('e2mYq'));